import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgIdleModule } from '@ng-idle/core';
import { AuthInterceptor } from 'angular-auth-oidc-client';
import { CookieService } from 'ngx-cookie-service';
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { environment } from 'src/environments/environment';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { AuthConfigModule } from './auth/auth-config.module';
import { DebugLogHttpInterceptor } from './core/interceptors/debug-log.interceptor';
import { ErrorInterceptor } from './core/interceptors/error.interceptor';
import { InsuranceInterceptor } from './core/interceptors/insurance.interceptor';
import { InterestRateInterceptor } from './core/interceptors/interest-rate.interceptor';
import { LoanTypeInterceptor } from './core/interceptors/loan-type.interceptor';
import { MockHttpInterceptor } from './core/interceptors/mock-http.interceptor';
import { NoCacheHttpInterceptorService } from './core/interceptors/no-cache.interceptor';
import { NoOpInterceptor } from './core/interceptors/no-op.interceptor';
import { ProposalLimitInterceptor } from './core/interceptors/proposal-limit.interceptor';
import { SpinnerInterceptor } from './core/interceptors/spinner.interceptor';
import { TokenInterceptor } from './core/interceptors/token.interceptor';
import { AppDynamicsModule } from './modules/app-dynamics/app-dynamics.module';
import { LiveChatModule } from './modules/live-chat/live-chat.module';
import { SharedModule } from './shared/shared.module';
@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
    HttpClientModule,
    NgIdleModule.forRoot(),
    AuthConfigModule,
    LoggerModule.forRoot({
      level: NgxLoggerLevel.DEBUG,
      serverLogLevel: NgxLoggerLevel.ERROR
    }),
    LiveChatModule.forRoot(),
    AppDynamicsModule.forRoot()
  ],
  declarations: [AppComponent],
  providers: [
    // { provide: ErrorHandler, useClass: AppErrorHandlerService },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NoCacheHttpInterceptorService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: DebugLogHttpInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterestRateInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoanTypeInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InsuranceInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useFactory: () =>
        !environment.production &&
        environment.useMockInterceptor &&
        environment.type === 'local'
          ? new MockHttpInterceptor()
          : new NoOpInterceptor(),
      multi: true
    },
    // {
    //   provide: ErrorHandler,
    //   useClass: AppErrorHandlerService
    // },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ProposalLimitInterceptor,
      multi: true
    },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    CookieService,
    { provide: HTTP_INTERCEPTORS, useClass: SpinnerInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
